/*global jQuery:false */
jQuery(document).ready(function () {
    'use strict';

    // default value for fancybox
    jQuery.extend(jQuery.fancybox.defaults, {
        padding: 0,
        margin: [20, 20, 20, 20],
        autoCenter: true, 
        closeBtn: false,
        beforeLoad: function(){
            $('html.vitrine').addClass('fancybox--open');
        },
        afterClose: function(){
            $('html.vitrine').removeClass('fancybox--open');
        },
        tpl: {
            wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
            image: '<img class="fancybox-image" src="{href}" alt="" />',
            iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allowtransparency="true"></iframe>',
            error: '<p class="fancybox-error">' + TINK.tr('common.fancybox.error') + '</p>',
            next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
            prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
        }
    });
});